import "../dashboard.css";
import { Bar } from "react-chartjs-2";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';




ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    Legend,
    ChartDataLabels
);


export default function GroupedFarmsByCountry({ data }) {

    return (
        <div>
            {
                data ?
                    <Bar
                        data={{
                            labels: Object.keys(data),
                            datasets: [
                                {
                                    label: 'Farms Grouped by Country',
                                    data: Object.values(data).map(farms => farms.length),
                                    backgroundColor: 'rgba(54, 240, 30, 0.6)',
                                },
                            ],
                        }}
                        options={{
                            responsive: true,
                            
                            plugins: {
                                legend: {
                                    position: 'top',
                                },
                                datalabels: {
                                    display: true, // Enable data labels
                                    color: 'black', // Color of the labels
                                    anchor: 'end', // Position of the label relative to the bar (e.g., 'end', 'center', 'start')
                                    align: 'end', // Alignment of the label text
                                    formatter: (value, context) => {
                                        // Optional: Customize the displayed value
                                        return Object.values(data)[context.dataIndex].length;
                                    },
                                },

                            }
                        }}
                className="barchartdiseasesbycountry"
                    />
                    : null}

        </div>
    )
}